import { createAction } from '@reduxjs/toolkit';
const GET_FEATURES_REQUEST = 'GET_FEATURES_REQUEST';
const GET_FEATURES_SUCCESS = 'GET_FEATURES_SUCCESS';
const GET_FEATURES_FAILURE = 'GET_FEATURES_FAILURE';
const getFeaturesRequest = createAction(GET_FEATURES_REQUEST);
const getFeaturesSuccess = createAction(GET_FEATURES_SUCCESS);
const getFeaturesFailure = createAction(GET_FEATURES_FAILURE);
export const actions = {
    request: getFeaturesRequest,
    success: getFeaturesSuccess,
    failure: getFeaturesFailure,
};
